import sequentialCommandReducer from "./reducers";

export default sequentialCommandReducer;